import { call } from '@packages/functions';
import { find } from 'lodash';
import { Model } from './Model';

export interface ColorType {
    id: number;
    name: string;
    category: string;
    hex: string;
    description: string;
}

export const Color = Model<ColorType>('Color', {
    endpoint: 'apparel-colors',
})`
    id:Int;
    name:String;
    category:String;
    hex:String;
    description:String;
`;

type SearchColor = ((texture: ColorType) => boolean) | ColorType | string | number | null | undefined;

export const areColorsMatching = (color: ColorType, search: SearchColor): boolean => {
    if (color === search) {
        return true;
    }

    if (typeof search === 'number') {
        search = `${search}`;
    }

    if (typeof search === 'string') {
        return `${color.id}` === search || `${color.hex}` === search;
    }

    if (search && typeof search === 'object') {
        return `${color.id}` === `${(search as any).id}` || `${color.hex}` === `${(search as any).hex}`;
    }

    return !!call(search as any, color);
};

export const findColor = (colors: ColorType[], search: SearchColor): ColorType | null => {
    return !search ? null : find(colors, (color: ColorType) => areColorsMatching(color, search)) || null;
};
